import FlowChart from './FlowChart.vue'

FlowChart.install = Vue => Vue.component(FlowChart.name, FlowChart) // 给组件配置install方法

export default FlowChart
